import { apiClient } from '../client';

/**
 * SU-5 (W7): browser errors reported to POST /api/client-errors
 * (lib/clientErrorReporter.ts), read by the super admin.
 */

export type ClientErrorKind = 'error' | 'unhandledrejection' | 'boundary';
export const CLIENT_ERROR_KINDS: ClientErrorKind[] = ['error', 'unhandledrejection', 'boundary'];

export interface ClientErrorItem {
  id: string;
  kind: ClientErrorKind;
  name: string;
  message: string;
  stack: string;
  route: string;
  release: string;
  browser: string;
  count: number;
  fingerprint: string;
  created_at: string;
}

export interface ClientErrorFilters {
  kind?: ClientErrorKind;
  route?: string;
  q?: string;
  fingerprint?: string;
  from?: string;
  to?: string;
}

export function listClientErrors(filters: ClientErrorFilters, page: { limit: number; cursor?: string }, signal?: AbortSignal) {
  return apiClient.get<{ items: ClientErrorItem[]; next_cursor: string | null; total: number }>('/admin/client-errors', {
    signal,
    query: { ...filters, limit: page.limit, cursor: page.cursor },
  });
}
